import changeCase from 'change-case-object'
import MessengerExtensions from './messengerExtensions'
import apiFetch from './apiFetch'

export default {
  MessengerExtensions,
  profile: {
    getMe(threadContext) {
      return apiFetch('/api/profile', { payload: threadContext })
    },
    get(id, threadContext) {
      return apiFetch(`/api/profile/${id}`, {
        payload: threadContext,
        targetUserId: id
      })
    },
    getMatches(threadContext) {
      return apiFetch('/api/matches', { payload: threadContext })
    },
    deleteMatch(match, threadContext) {
      return apiFetch(`/api/delete-match/${match.senderId}`, {
        payload: threadContext
      })
    },
    requestLocationChange(threadContext) {
      return apiFetch('/api/update-location', { payload: threadContext })
    },
    requestAgeSubmit(threadContext) {
      return apiFetch('/api/update-age', { payload: threadContext })
    },
    uploadImage(threadContext, imageNumber, file, oldImage) {
      const data = new FormData()
      data.append('file', file)
      data.append(
        'payload',
        JSON.stringify(changeCase.snakeCase(threadContext))
      )
      data.append('picnum', imageNumber)
      oldImage && data.append('old_pic_url', oldImage.url)

      return apiFetch('/api/upload-image', data, {
        send: 'form-data'
      })
    },
    deleteImage(imageUrl, threadContext) {
      return apiFetch('/api/remove-image', {
        payload: threadContext,
        picurl: imageUrl
      })
    },
    report(userId, report, threadContext) {
      const userReport = {
        reportedUserSenderId: userId,
        reportReason: report.text,
        reportReasonId: report.id
      }

      return apiFetch('/api/report-user', {
        payload: threadContext,
        userReport
      })
    },
    requestDeleteAccount(threadContext) {
      return apiFetch('/api/request-delete-account', { payload: threadContext })
    },
    updateSettings(settings, threadContext) {
      return apiFetch('/api/update-settings', {
        payload: threadContext,
        settings
      })
    },
    addFacebookUserData(facebookUserData, threadContext) {
      return apiFetch('/api/add-facebook-user-data', {
        facebookUserData,
        payload: threadContext
      })
    }
  },
  likedislike: {
    get(threadContext) {
      return apiFetch('/api/likedislike', { payload: threadContext })
    },
    setLike(crush, threadContext) {
      if (!crush.senderId) {
        return Promise.reject(new Error('no senderId for user found'))
      }

      return apiFetch('/api/like', {
        payload: threadContext,
        crushPartner: crush
      })
    },
    setDislike(crush, threadContext) {
      if (!crush.senderId) {
        return Promise.reject(new Error('no senderId for user found'))
      }

      return apiFetch('/api/dislike', {
        payload: threadContext,
        crushPartner: crush
      })
    },
    revokeAction(crush, threadContext) {
      if (!crush.senderId) {
        return Promise.reject(new Error('no senderId for user found'))
      }

      return apiFetch('/api/revoke-likes', {
        payload: threadContext,
        crushPartner: crush
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/api.js